import { apiFetch } from '@/services/core/apiFetch'
import { getContext } from '@/services/core/context'

const API_ROOT = import.meta.env.VITE_ADNUNTIUS_API_BASE || 'https://api.dev.adnuntius.com/api'

export interface SearchResult {
  type: string
  id: string
  url: string
  objectState: string
  name: string
  summary: string
  lastModifiedBy: string
  lastModifiedId: string
}

export interface AggregationBucket {
  name: string
  filter: string
  count: number
}

export interface Aggregation {
  buckets: Record<string, AggregationBucket>
}

export interface SearchResponse {
  totalHits: number
  pageStart: number
  pageEnd: number
  searchResults: SearchResult[]
  aggregations: {
    types: Aggregation
    exclusionLabels: Aggregation
    objectState: Aggregation
    lastModifiedIn: Aggregation
    lastModifiedBy: Aggregation
    matchingLabels: Aggregation
    rateControlLabels: Aggregation
    labels: Aggregation
  }
}

export interface SearchParams {
  q: string
  pageSize?: number
  objectState?: string
  labels?: string
  orderBy?: string
  types?: string
}

export const SearchApi = {
  search: async (params: SearchParams): Promise<SearchResponse> => {
    const context = getContext()
    const query = new URLSearchParams({
      context,
      q: params.q,
      pageSize: String(params.pageSize ?? 10),
      objectState: params.objectState ?? 'ACTIVE',
      labels: params.labels ?? '',
      types: params.types ?? '',
    })
    // Only sent when asked for, so the server picks its own ordering otherwise.
    if (params.orderBy) query.set('orderBy', params.orderBy)

    const res = await apiFetch(`${API_ROOT}/v1/search?${query}`, {
      headers: { 'Content-Type': 'application/json' },
    })
    if (!res.ok) throw new Error(`Search failed (${res.status})`)
    return res.json()
  },
}
